<template>
  <div class="dropdown dropdown-message">
    <a
      @click="loadConversation()"
      class="dropdown-link wd-60 d-flex align-items-center justify-content-center"
      data-toggle="dropdown"
      role="button"
    >
      <img :src="`${myResBaseUrl}v4-assets/svgicon/communication/outline/chat 01.svg`" class="wd-32" />
      <span>{{ this.$store.state.signalr.team.notSeenConversationCount }}</span>
    </a>
    <div class="dropdown-menu dropdown-menu-right" >
      <div class="dropdown-header bd-b-0-f mg-b-0-f tx-bold-f tx-20-f" style="text-transform: none;">Шинэ зурвасууд</div>
      <div style="height:50vh; overflow-y:auto">
      <template v-for="conv in conversations">
        <router-link
          :to="`/lms/courseView/${conv.courseId}/0/0/0`"
          :class="`rounded mg-b-3-f dropdown-item ${conv.count > 0 ? 'bg-light' : 'bg-gray-100'}`"
          :key="conv.id"
        >
          <div class="media">
            <div class="avatar">
              <img
                :src="`${conv.lastMessage.user.avator}?w=32&h=32&mode=crop`"
                class="rounded"
                :alt="conv.lastMessage.user.fullName"
              />
            </div>
            <div class="media-body mg-l-15">
              <strong class="tx-12"
                >{{ conv.lastMessage.user.fullName }} - <b class="tx-semibold">{{ conv.team }}</b></strong
              > <strong class="tx-12"> {{ conv.lastMessage.msg }}</strong>
              <p class="text-muted tx-10">{{ conv.lastMessage.date | moment('from') }}</p>
            </div>
          </div>
        </router-link>
      </template>
    </div>
      <!-- <div class="dropdown-footer">
        <a href>Бүх Зурвас</a>
      </div>-->
    </div>
    <!-- dropdown-menu -->
  </div>
</template>

<script>
import { request } from "@/api/all";
import { mapActions } from "vuex";

export default {
  props: {
    prop: {
      flag: Number,
      default: () => 115
    }
  },
  data() {
    return {
      conversations: [],
      notSeenCount: 0,
      myResBaseUrl: "https://res.gosmart.mn/"
    };
  },
  created() {
    if (
      this.$store.state.app.activeGroup.resBaseUrl != undefined &&
      this.$store.state.app.activeGroup.resBaseUrl != ""
    ) {
      this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
    }
  },
  mounted() {
    this.loadNotSeenCount();
  },
  methods: {
    ...mapActions(["handleTeamNotSeenCount"]),
    loadNotSeenCount() {
      request({
        api: { method: "get", url: "team/NotSeenConversationCount" },
        params: { flag: 115 },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.handleTeamNotSeenCount(res.data.count);
        }
      });
    },
    loadConversation() {
      request({
        api: { method: "get", url: "team/GetTeamConversations" },
        params: { id: 0, flag: 115, skip: 0, size: 10 },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.conversations = res.data.conversations;
          this.loadNotSeenCount();
        }
      });
    }
  }
};
</script>
